import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {RootState} from 'App/store/rootReducer';

import {TConstructionCosts} from './constructionCosts.types';

type ConstructionCostsSlice = {
  costs: null | TConstructionCosts;
};

const initialState: ConstructionCostsSlice = {
  costs: null,
};

const constructionCostsSlice = createSlice({
  name: 'constructionCosts',
  initialState,
  reducers: {
    setConstructionCosts: (
      state,
      {payload}: PayloadAction<TConstructionCosts>,
    ) => {
      state.costs = payload;
    },
    resetConstructionCosts: () => initialState,
  },
});

export const selectConstructionCosts = (
  state: RootState,
): ConstructionCostsSlice => state.map3DEntities.constructionCosts;

const mapConstructionCostsToProps = (
  state: RootState,
): ConstructionCostsSlice => state.map3DEntities.constructionCosts;

export const connectToConstructionCosts = connect(
  mapConstructionCostsToProps,
  null,
  null,
  {forwardRef: true},
);

export const {setConstructionCosts, resetConstructionCosts} =
  constructionCostsSlice.actions;

export default constructionCostsSlice.reducer;
